export class CssVariables {
    static init() {
        this.setScrollbarWidth();
        this.bindEvents();
    }
 
    private static bindEvents() {
        window.addEventListener('resize', this.setScrollbarWidth);
    }

    private static setScrollbarWidth() {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth / 2}px`);
    }
}